import clsx from "clsx";
import React, {useState} from "react";
import AdminDashboardTwoColumnLayout from "../components/AdminDashboardTwoColumnLayout";
import DatePickerCard from "./DatePickerCard";
import DataTable from "./DataTable";

const AdminDataTable = () => {
    const date = new Date();
    const today = new Date(date.getFullYear(), date.getMonth(), 0);
    const twoMonths = new Date(date.getFullYear(), date.getMonth() - 1, 1);

    const [startDate, setStartDate] = useState(twoMonths);
    const [endDate, setEndDate] = useState(today);
    const [period, setPeriod] = useState(2);

    return (
        <div className={clsx("AdminDashboard flex relative z-2 justify-evenly flex w-full h-full flex-col items-stretch ml-auto mr-auto")}>
            <AdminDashboardTwoColumnLayout
                contentLeft={
                    <>
                        <DataTable />
                    </>
                }
                contentRight={
                    <>
                        <DatePickerCard
                            endDate={endDate}
                            period={period}
                            setEndDate={setEndDate}
                            setPeriod={setPeriod}
                            setStartDate={setStartDate}
                            startDate={startDate}
                        />
                    </>
                }
            ></AdminDashboardTwoColumnLayout>
        </div>
    );
};

export default AdminDataTable;
